import React from "react";
import {Typography, FormGroup, Checkbox, FormControl, FormLabel, FormControlLabel,Radio, RadioGroup, Grid, Dialog, DialogActions, TextField, DialogContent, DialogTitle } from "@mui/material";
import styles from './FormAuth.module.css';
import CustomButtons from "../../../common/CustomButtons/CustomButtons";

 
const ElectricLiftAuthorizationForm = ({handleClose, preAuthFormData}) => {

    return (
      <>
      {preAuthFormData  && (
           
           <Dialog 
           fullWidth
           maxWidth="md"
           open={true}  
           onClose={handleClose} 
           >
           <DialogTitle sx={{ m: 0, p: 2 }} className={styles.DialogTitle}> Electric Lift System Pre-Authorization Documentation  </DialogTitle>
           
           
           <DialogContent>
           <Typography sx={{margin: '10px 0px'}}><span className={styles.asterisk}>*</span> denotes required field</Typography>
              {preAuthFormData[0]?.BranchCode !== undefined && preAuthFormData[0]?.BranchCode !== '' && <Grid container>
               <Grid xs={12} md={6} className={styles.spacingTop} sx={{marginTop:'0px !important'}}>
               <FormControl className={styles.spacingRemoveTop}>  
                 <div>
                   <Typography className={styles.labelText}> Branch/State (3 letter code) <span className={styles.asterisk}>*</span> </Typography>
                 </div>
                 <div >
                 <TextField
                     size="small"
                     autoFocus
                     fullWidth
                     id="name"
                     type="text"
                     margin="normal"
                     variant="outlined"
                     maxLength="3"
                     value={preAuthFormData[0].BranchCode}
                     inputProps={{ style: { cursor: 'not-allowed' } }}
                     sx={{marginTop: '5px', backgroundColor:'var(--color-disableField)'}}
                     disabled={true}
                 />
                 </div>
                 </FormControl>
               </Grid>
             </Grid>}
   
   {preAuthFormData[0]?.ResideType !== undefined && <Grid container>
     <Grid xs={12} className={styles.spacingTop}>
     <FormControl className={styles.spacingRemoveTop}>  
   <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label">1. Patient will reside:<span className={styles.asterisk}>*</span></FormLabel>
         <RadioGroup
          value={preAuthFormData[0].ResideType}
           row
           aria-labelledby="demo-row-radio-buttons-group-label"
           name="row-radio-buttons-group"
         >
           <FormControlLabel value="1" control={<Radio />} label="Home" disabled={true} sx={{ cursor: 'not-allowed' }}/>
           <FormControlLabel value="2" control={<Radio />} label="SNF/ALF/ILF" disabled={true} sx={{ cursor: 'not-allowed' }}/>
           
         </RadioGroup>
       </FormControl>
     </Grid>
   </Grid>}
   
   {preAuthFormData[0]?.HoyerEnabled !== undefined && preAuthFormData[0]?.HoyerEnabled !== '' && <Grid container>
     <Grid xs={12} className={styles.spacingTop}>
     <FormControl className={styles.spacingRemoveTop}>  
   <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label"> 2. Is the caregiver able to utilize a manual pneumatic "hoyer" lift system? <span className={styles.asterisk}>*</span></FormLabel>
         <RadioGroup
         value={preAuthFormData[0].HoyerEnabled}
           row
           aria-labelledby="demo-row-radio-buttons-group-label"
           name="row-radio-buttons-group"
         >
           <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true}/>
           <FormControlLabel value="false" control={<Radio />} label="No" disabled={true}/>
           
         </RadioGroup>
       </FormControl>
     </Grid>
   </Grid>}

   {preAuthFormData[0]?.HoyerReason !== undefined && preAuthFormData[0]?.HoyerReason !== '' && <Grid container sx={{paddingLeft:'10px'}}>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
       a. If no, please list reason(s):
       </Typography>
     </div>
     <TextField
               fullWidth
               aria-label="minimum height"
               minRows={2}
               multiline
               rows={3}
               maxLength={500}
               size="small"
               value={preAuthFormData[0].HoyerReason}
               sx={{marginTop:'5px',cursor:'not-allowed', backgroundColor:'var(--color-disableField)'}}
               disabled={true}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}

   
   
   { preAuthFormData[0]?.HasLiftSystem !== undefined && <Grid container>
     <Grid xs={12} className={styles.spacingTop}>
     <FormControl className={styles.spacingRemoveTop}>  
   <FormLabel className={styles.labelText} id="demo-row-radio-buttons-group-label"> 3. Does the patient currently have an electrical lift system? <span className={styles.asterisk}>*</span></FormLabel>
         <RadioGroup
         value={preAuthFormData[0].HasLiftSystem}
           row
           aria-labelledby="demo-row-radio-buttons-group-label"
           name="row-radio-buttons-group"
         >
           <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true}/>
           <FormControlLabel value="false" control={<Radio />} label="No" disabled={true}/>
           
         </RadioGroup>
       </FormControl>
     </Grid>
   </Grid> }

   {preAuthFormData[0]?.LiftSystemRationale !== undefined && preAuthFormData[0].LiftSystemRationale !== '' && <Grid container sx={{paddingLeft:'10px'}}>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
       a. If no, what is the clinical rationale for using an electrical lift system: <span className={styles.asterisk}>*</span>
       </Typography>
     </div>
     <TextField
               fullWidth
               aria-label="minimum height"
               multiline
               minRows={3}
               maxLength={500}
               size="small"
               value={preAuthFormData[0].LiftSystemRationale}
               sx={{marginTop:'5px',cursor:'not-allowed', backgroundColor:'var(--color-disableField)'}}
               disabled={true}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}
   
   
   { preAuthFormData[0]?.HasProvisionElectricPenumatic !== undefined && preAuthFormData[0].HasProvisionElectricPenumatic !== '' &&  <Grid container>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
        4. Are there any extenuating circumstances that require the provision of an electric lift vs. pneumatic lift? <span className={styles.asterisk}>*</span>
       </Typography>
     </div>

          <RadioGroup
          value={preAuthFormData[0].HasProvisionElectricPenumatic}
           row
           aria-labelledby="demo-row-radio-buttons-group-label"
           name="row-radio-buttons-group"
         >
           <FormControlLabel value="true" control={<Radio />} label="Yes" disabled={true} sx={{ cursor: 'not-allowed' }}/>
           <FormControlLabel value="false" control={<Radio />} label="No" disabled={true} sx={{ cursor: 'not-allowed' }}/>
           
         </RadioGroup>
     </Grid>
   </Grid>}

   {preAuthFormData[0]?.ProvisionElectricPenumaticExplanation !== undefined && preAuthFormData[0].ProvisionElectricPenumaticExplanation !== '' && <Grid container sx={{paddingLeft:'10px'}}>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
       a.  If yes, please explain:
       </Typography>
     </div>
     <TextField
               fullWidth
               aria-label="minimum height"
               multiline
               minRows={3}
               maxLength={500}
               size="small"
               value={preAuthFormData[0].ProvisionElectricPenumaticExplanation}
               sx={{marginTop:'5px',cursor:'not-allowed', backgroundColor:'var(--color-disableField)'}}
               disabled={true}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}
   
   
   
   {preAuthFormData[0]?.IsRequestedBySNFALF !== undefined && preAuthFormData[0]?.IsRequestedBySNFALF !== ''  && <Grid container>
     <Grid xs={12}>
     <FormControl className={styles.spacingRemoveTop}>  
     <FormGroup>
         <FormControlLabel control={<Checkbox checked={preAuthFormData[0].IsRequestedBySNFALF} disabled={true} />} label="Requested by SNF/ALF as their facility standard" />
       </FormGroup>
       </FormControl>
     </Grid>
   </Grid>}
   
   
   {preAuthFormData[0].RequestingFacility !== undefined && preAuthFormData[0].RequestingFacility !== '' && <Grid container>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
               Name of requesting facility
       </Typography>
     </div>
     <TextField
               fullWidth
               minRows={2}
               maxLength={200}
               size="small"
               aria-label="minimum height"
               disabled={true}
               value={preAuthFormData[0].RequestingFacility}
               sx={{marginTop:'5px', backgroundColor:'var(--color-disableField)'}}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}
   
   
   {preAuthFormData[0].ClinicianName !== undefined && preAuthFormData[0].ClinicianName !== '' && <Grid container>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
               Clinician Name <span className={styles.asterisk}>*</span>
       </Typography>
     </div>
     <TextField
               fullWidth
               maxLength={200}
               minRows={2}
               size="small"
               aria-label="minimum height"
               value={preAuthFormData[0].ClinicianName}
               sx={{marginTop:'5px',cursor:'not-allowed', backgroundColor:'var(--color-disableField)'}}
               disabled={true}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}
   
   
   {preAuthFormData[0].ApprovingManager !== undefined && preAuthFormData[0].ApprovingManager !== '' && <Grid container>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
               ED/Admin <span className={styles.asterisk}>*</span>
       </Typography>
     </div>
     <TextField
               aria-label="minimum height"
               maxLength={200}
               fullWidth
               minRows={2}
               size="small"
               value={preAuthFormData[0].ApprovingManager}
               sx={{marginTop:'5px',cursor:'not-allowed', backgroundColor:'var(--color-disableField)'}}
               disabled={true}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}
   
   {preAuthFormData[0].AVPO !== undefined&& preAuthFormData[0].AVPO !== '' && <Grid container>
     <Grid xs={12} className={styles.spacingTop}> 
     <div>
       <Typography className={styles.labelText}>
               AVPO <span className={styles.asterisk}>*</span>
       </Typography>
     </div>
     <TextField
     fullWidth
               maxLength={200}
               minRows={2}
               aria-label="minimum height"
               size="small"
               value={preAuthFormData[0].AVPO}
               sx={{marginTop:'5px', backgroundColor:'var(--color-disableField)'}}
               disabled={true}
               inputProps={{ style: { cursor: 'not-allowed' } }}
             />
     </Grid>
   </Grid>}
   
   
   
         
           </DialogContent>
   
   <Grid container sx={{justifyContent:'end'}}>
     <Grid>
     <DialogActions
                 style={{ justifyContent: "end", padding: "14px 16px" }}
               >
                 <CustomButtons
                 type="button" 
                 text="Close" 
                 onClick={handleClose} 
                 />
               </DialogActions>
     </Grid>
   </Grid>
           
         </Dialog>
      )}
     
    </>
    )
}

ElectricLiftAuthorizationForm.formName = "ElectricLiftAuthorizationForm";
export default ElectricLiftAuthorizationForm;